var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewindCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.634 20.44a5.343 5.343 0 01-1.258-4.669 5.283 5.283 0 00-3.56-6.159 5.357 5.357 0 01-3.427-3.427 5.3 5.3 0 00-6.16-3.56 5.234 5.234 0 01-4.668-1.258 5.322 5.322 0 00-7.12 0 5.344 5.344 0 01-4.67 1.258 5.283 5.283 0 00-6.158 3.56 5.357 5.357 0 01-3.427 3.427 5.3 5.3 0 00-3.56 6.159 5.234 5.234 0 01-1.258 4.669 5.322 5.322 0 000 7.12 5.343 5.343 0 011.258 4.669 5.283 5.283 0 003.56 6.159 5.358 5.358 0 013.427 3.427 5.3 5.3 0 006.159 3.56 5.234 5.234 0 014.669 1.258 5.322 5.322 0 007.12 0 5.343 5.343 0 014.669-1.258 5.283 5.283 0 006.159-3.56 5.359 5.359 0 013.427-3.427 5.3 5.3 0 003.56-6.159 5.234 5.234 0 011.258-4.669 5.322 5.322 0 000-7.12z",
    fill: "url(#rewind-circle_svg__paint0_linear_644_8062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rewind-circle_svg__paint0_linear_644_8062",
    x1: 9.218,
    y1: 8.401,
    x2: 40.08,
    y2: 39.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D291F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#992FD1"
  })))));
}
export default SvgRewindCircle;